import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorEvents = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M5.75 21.25H4.5a.75.75 0 0 0 0 1.5h4.6a.75.75 0 0 0 0-1.5H7.25v-6.5H20.5a.75.75 0 0 0 .675-1.075L19.166 9.5l2.01-4.175A.75.75 0 0 0 20.5 4.25H7.25V3a.75.75 0 1 0-1.5 0v18.25Zm1.5-15.5v7.5h12.056l-1.649-3.425a.75.75 0 0 1 0-.65l1.65-3.425H7.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M9.7 8.4c0-.22.179-.4.4-.4h4.7c.22 0 .4.18.4.4v2.2a.4.4 0 0 1-.4.4h-4.7a.4.4 0 0 1-.4-.4V8.4Z"
    />
  </svg>
);
export default SvgTwoColorEvents;
